import { useSelector } from "react-redux";

const HasRole = ({ roles = [], children }) => {
  const userRole = useSelector((state) => state.user?.role);

  if (!roles.length || roles.includes(userRole)) {
    return children;
  }

  return null;
};

export default HasRole;
